import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { CookiesKeys, URLs, imageType } from "../../Constants/Consts";
import { removePLFromNotSyncDeletedPunchLists, rollbackPendingPunchList, updatePunchlistItem } from "../../store/PunchList";
import { ObjectToSync, UUID } from "../../types/types";
import { SyncItemsTypes } from "./SyncItemsTypes";
import { photosKeys } from "../DownloadManager/storePunchList";
import Cookies from "js-cookie";
import { PhotoType } from "../../Pages/PunchList/DetailsPage/PunchListEditImagesPage";
import { mapPunchListToAPI } from "../../Helpers/Mappers";

// track punchlists
export default function (): { getPunchlistsToSync: () => Promise<ObjectToSync>[], updateSyncItem: (itemId: UUID) => void, cancelSyncItem: (itemId: UUID) => void } {
    const dispatch = useDispatch()
    const { ProjectPunchLists, notSyncDeletedPunchLists } = useSelector((state: RootState) => state.PunchList)
    if (!Array.isArray(ProjectPunchLists)) return { getPunchlistsToSync: () => [], updateSyncItem: () => { }, cancelSyncItem: () => { } }
    const { SelectedUser } = useSelector((state: RootState) => state.SelectedUser)

    const getPunchlistsToSync = () => {
        // get all the notSync items 
        const filteredLists = ProjectPunchLists.filter(p => {
            const isPhotosNotSyncArray = Object.keys(photosKeys).map(k => p[photosKeys[k]]?.notSync)
            return p.notSync || isPhotosNotSyncArray.some(ns => ns)
        }).concat(notSyncDeletedPunchLists)
        const jwt = Cookies.get(CookiesKeys.jwt)
        return filteredLists.map(async (pl) => {
            const preRequests = []
            const keysArray = Object.keys(photosKeys)
            for (let i = 0; i < keysArray.length; i++) {
                const photoKey = keysArray[i];
                const photoLabel = photosKeys[photoKey] as string
                if (pl[photoLabel]?.notSync) {
                    const photoType = photoLabel.toLocaleLowerCase().includes("def") ? PhotoType.DEFECT : PhotoType.CORRECTED
                    const photoNumber = i % 2 + 1
                    const url = URLs.postFilePunchListImage(SelectedUser.projectNumber, pl.punchListUuid, photoType)
                    const method = !pl[photoLabel]?.creation ? "PUT" : "POST"
                    const photoName = `${pl.punchListUuid}.${photoType.toLowerCase()}_pic_${photoNumber}.${imageType}`;
                    const it = {
                        url,
                        method,
                        payload: { value: pl[photoLabel]?.value, photoName, photoType, label: `${photoType.toLowerCase()}Pic${photoNumber}` },
                        type: SyncItemsTypes.PunchlistItem
                    }
                    preRequests.push(it)
                }
            }
            const url = pl.deletion ? URLs.deletePunchListUrl(pl.punchListUuid) : !pl.creation ? URLs.putPunchListUrl(pl.punchListUuid) : URLs.postPunchListsUrl()
            const method = pl.deletion ? "DELETE" : !pl.creation ? "PUT" : "POST"
            const { notSync, creation, deletion, rollbackSnapshot, syncIgnoreConflict, ...existingPayload } = pl
            const mappedPl = pl.creation ? mapPunchListToAPI(pl) : existingPayload
            return {
                url,
                method,
                payload: mappedPl,
                type: SyncItemsTypes.PunchlistItem,
                preRequests,
                jwt,
                syncMeta: {
                    queueId: `punchlist:${pl.punchListUuid}`,
                    itemId: pl.punchListUuid,
                    itemLabel: pl.punchListTag || pl.issueDesc || pl.punchListUuid,
                    resourceType: SyncItemsTypes.PunchlistItem,
                    localBaseTimestamp: pl.dateCompleted || pl.dateIdentified || null,
                    localUpdatedAt: new Date().toISOString(),
                    ignoreConflictCheck: !!syncIgnoreConflict,
                }
            }
        })
    }

    const updateSyncItem = (punchlistId) => {
        const toUpdateIndex = ProjectPunchLists.findIndex(pl => pl.punchListUuid.toLocaleUpperCase() === punchlistId?.toLocaleUpperCase?.())
        if (toUpdateIndex >= 0) {
            const toUpdate = structuredClone(ProjectPunchLists[toUpdateIndex])
            const keysArray = Object.keys(photosKeys)
            for (let i = 0; i < keysArray.length; i++) {
                const storedPhotoKey = photosKeys[keysArray[i]]
                toUpdate[storedPhotoKey] = { ...toUpdate[storedPhotoKey], notSync: false }
            }
            dispatch(updatePunchlistItem({ ...toUpdate, notSync: false, creation: false, syncIgnoreConflict: false }))
        }else{
            const toUpdateIndex = notSyncDeletedPunchLists.findIndex(pl => pl.punchListUuid.toLocaleUpperCase() === punchlistId?.toLocaleUpperCase?.())
            if (toUpdateIndex >= 0) {
                const toUpdate = notSyncDeletedPunchLists[toUpdateIndex]
                dispatch(removePLFromNotSyncDeletedPunchLists({ uuid: toUpdate.punchListUuid }))
            }
        }
    }
    const cancelSyncItem = (punchlistId) => {
        if (!punchlistId) return
        dispatch(rollbackPendingPunchList({ uuid: punchlistId }))
    }

    return { getPunchlistsToSync, updateSyncItem, cancelSyncItem }
}

